$(function() {
    $('.list-crafts-item--video .craft-asset')
      .on('mouseenter', function(e) {
          var videoElem = e.currentTarget;
          var $video = $(videoElem);
          var $container = $video.closest('.craft');

          $container.addClass('play');
          videoElem.play();
      })
      .on('mouseleave', function(e) {
          var videoElem = e.currentTarget;
          var $video = $(videoElem);
          var $container = $video.closest('.craft');

          videoElem.pause();
          videoElem.currentTime = 0;
          $container.removeClass('play');
      });
    $('.list-craftsmanship-item--video .craftsmanship-asset')
      .on('mouseenter', function(e) {
          var videoElem = e.currentTarget;
          var $video = $(videoElem);
          var $container = $video.closest('.craftsmanship');

          $container.addClass('play');
          videoElem.play();
      })
      .on('mouseleave', function(e) {
          var videoElem = e.currentTarget;
          var $video = $(videoElem);
          var $container = $video.closest('.craftsmanship');

          videoElem.pause();
          videoElem.currentTime = 0;
          $container.removeClass('play');
      });
  
	// Toggle Mini Cart
	$('.mini-cart-toggle').on('click', function(e) {
		e.preventDefault();
		//loadCart();
		$('.mini-cart').toggleClass('visible');
		$('html').toggleClass('no-scroll');

		if($('.mini-cart').hasClass('visible')) {
			cartget();
		}
	});

	$(document).on('click', '.sku-atc:not(.soldout)', function(e) {
		e.preventDefault();

		// if (typeof $(this).data('cat-name') != 'undefined' && typeof ga !== 'undefined') {
		// 	ga('send', 'event', 'Category Page', 'Add to Cart' , $(this).data('cat-name'));
		// }

		//For facebook
		// var sku_data = {
		// 	itemId : $(this).data('sku-id'),
		// 	product_name : $(this).data('label'),
		// 	price:$(this).data('price')
		// }

		// facebookATCEvent(sku_data);

		// sku_atc($(this).data('sku-id'));
		cartAdd($(this).data('variant-id'), 1, $(this).data('property-name'), $(this).data('property-value'));
	});

	$(document).on('click', function(event) {
		if ((!$(event.target).closest('.mini-cart').length) && (!$(event.target).closest('.mini-cart-toggle').length)) {
			$('.mini-cart').removeClass('visible');
			$('html').removeClass('no-scroll');
		}
	});

	$('.product-thumbs a').on('click', function(event) {
		setMainImage($(this));
		event.preventDefault();
	});

	if($('.mini-cart-item-quantity').length > 0){
		$('.mini-cart-item-quantity .field').on('change', function(e) {
			e.preventDefault();
			// var $target = $(this);
			// var qty = parseInt($target.val());
			// var id = $target.data('index');
			// quantityChange(id, qty);
			disabledSubmit();
			location.reload();
		});
		$('.mini-cart-item-quantity .quantity-decrease').on('click', function(e) {
			e.preventDefault();
			var $target = $(this).parent().siblings('input');
			var qty = parseInt($target.val()) - 1;
			var id = $target.data('index');
			quantityChange(id, qty);
		});
		$('.mini-cart-item-quantity .quantity-increase').on('click', function(e) {
			e.preventDefault();
			var $target = $(this).parent().siblings('input');
			var qty = parseInt($target.val()) + 1;
			var id = $target.data('index');
			quantityChange(id, qty);
		});
		$('.mini-cart .mini-cart-remove').on('click', function(e) {
			e.preventDefault();
			var index = $(this).data('index');
			cartClear(index);
		});
		$('.main-checkout .mini-cart-item .mini-cart-remove').on('click', function(e) {
			disabledSubmit();
		});
		$('.main-checkout .giftoption a').on('click', function(e) {
			disabledSubmit();
		});
	}

	if($('#keyboardWrap').length > 0) {
		keyboardFunc();
	}

	$('.main-checkout .mini-cart-personalize').on('click', function(e){
		e.preventDefault();
		var id = $(this).data('id');
		$('#personalize-popup-' + id ).toggle();
	});

	$('.form-section-personalize-actions a').on('click', function(e){
		e.preventDefault();
		let id = $(this).data('id');
		personalizeUpdate(id);
	});
});
// $(window).on('load', function() {
// 	let headerHeight = $('.header-sticky').outerHeight();
// 	let urlHash = location.hash;
// 	if (urlHash) {
// 		let position = $(urlHash).offset().top - headerHeight;
// 		$('html, body').animate({ scrollTop: position }, 0);
// 	}
// 	$('a[href^="#"]').on('click', function(){
// 		var href= $(this).attr('href');
// 		var target = $(href);
// 		var position = target.offset().top;
// 		$('body,html').stop().animate({scrollTop:position}, 400);
// 		return false;
// 	});
// });

function keyboardFunc() {
	let details = "#keyboardWrap";
	let summary = "#keyboardWrap .details__summary";
	let content = "#keyboardWrap .details_content";
	let speed = 200;
	$(summary).each(function () {
		$(this).on("click", function (event) {
			event.preventDefault();
			if ($(details).attr("open")) {
				$(content).slideUp(speed, function () {
					$(details).removeAttr("open");
					$(this).show();
				});
			} else {
				$(summary).each(function () {
					if ($(details).attr("open")) {
						$(content).slideUp(speed, function () {
							$(details).removeAttr("open");
							$(this).show();
						});
					}
				});
				$(details).attr("open", "true");
				$(content).hide().slideDown(speed);
			}
		});
	});
}

function changeSize(obj){
	const VARIANT_SELECTS = new VariantSelects(obj);
	let selected_option = Array.from(obj.querySelectorAll('select'), (select) => select.value)
	let thumbnail_list = document.querySelectorAll('#thumb-images li');
	let cnt = 0;

	let mainimage_target = document.querySelector('#main-images li.current');
	let thumbnail_target = document.querySelector('#thumb-images li.current');
	mainimage_target.classList.remove('current');
	thumbnail_target.classList.remove('current');

	thumbnail_list.forEach(function(element){
		let img = element.querySelector('img');
		let alt = img.getAttribute('alt');
		if(selected_option == alt) {
			cnt++;
			element.classList.remove('hidden');
			if(cnt === 1) {
				element.classList.add('current');
				let tab_id = element.querySelector('a').getAttribute('href');
				tab_id = tab_id.replace('#', '');
				let slide = document.getElementById(tab_id);
				slide.classList.add('current');
			}
		} else {
			element.classList.add('hidden');
		}
	});
}

function cartget() {
	let cartNotification = document.querySelector('cart-notification');
	let sectionArr = cartNotification.getSectionsToRender().map((section) => section.id)
	let sectionParam = sectionArr.join(",");
	const xhr = new XMLHttpRequest();
	xhr.open('GET', '/?sections='+sectionParam, true);
	xhr.send();
	xhr.onreadystatechange = () =>{
		if (xhr.readyState == 4 && xhr.status == 200) {
			const responseSectionObj = JSON.parse(xhr.responseText);
			sectionArr.forEach(section => {
				if(document.getElementById(section)) {
					document.getElementById(section).innerHTML = cartNotification.getSectionInnerHTML(responseSectionObj[section]);
				}
			});
			miniCartInits();
		}
	}
}

function miniCartInits() {
	$('.mini-cart .quantity-decrease').on('click', function(e) {
		e.preventDefault();
		var $target = $(this).parent().siblings('input');
		var qty = parseInt($target.val()) - 1;
		var index = $(this).data('index');
		quantityChange(index, qty, 'minicart');
	});
	$('.mini-cart .quantity-increase').on('click', function(e) {
		e.preventDefault();
		var $target = $(this).parent().siblings('input');
		var qty = parseInt($target.val()) + 1;
		var index = $(this).data('index');
		quantityChange(index, qty, 'minicart');
	});
	$('.mini-cart .mini-cart-remove').on('click', function(e) {
		e.preventDefault();
		var index = $(this).data('index');
		cartClear(index);
	});
}

function cartAdd(variantId, num=1, propertyName, propertyValue) {
	disabledSubmit();

	const config = fetchConfig();
	let formData = {
		items: [
			{
				id: variantId,
				quantity: num,
				properties: {
					[propertyName]: propertyValue
				}
			},
		]
	};
	config.body = JSON.stringify(formData);

	fetch(`${routes.cart_add_url}.js`, config)
	.then(response => response.json())
	.then(data => {
		$('html, body').animate({
			scrollTop: 0
		}, 1000);
		cartget();
		$('.mini-cart').addClass('visible');
	})
	.catch((error) => {
		console.log('Error:', error)
	})
}

function quantityChange(id, num, mode) {
	disabledSubmit();

	const config = fetchConfig();
	let formData = {
		'line': id,
		'quantity': num,
	};
	config.body = JSON.stringify(formData);

	fetch(`${routes.cart_change_url}.js`, config)
	.then(response => response.json())
	.then(data => {
		if(mode == 'minicart') {
			cartget();
		} else {
			location.reload();
		}
	})
	.catch((error) => {
		console.log('Error:', error)
	})
}

function personalizeUpdate(id) {
	disabledSubmit();

	let num = $('.line' + id + ' [name="updates[]"]').val();
	let propertyName = $('#personalize'+id).attr('name');
	propertyName = propertyName.replace('properties[', '').replace(']', '');
	let propertyValue = $('#personalize'+id).val();

	const config = fetchConfig();
	let formData = {
		'line': id,
		'quantity': num,
		'properties': {
			[propertyName]: propertyValue
		}
	};
	config.body = JSON.stringify(formData);

	fetch(`${routes.cart_change_url}.js`, config)
	.then(response => response.json())
	.then(data => {
		location.reload();
	})
	.catch((error) => {
		console.log('Error:', error)
	})
}

function cartClear(id=null) {
	const config = fetchConfig();

	let url = '';
	let formData = {};

	if(id != null) {
		url = `${routes.cart_change_url}.js`;
		formData = {
			'line': id,
			'quantity': 0,
		};
		config.body = JSON.stringify(formData);
	} else {
		url = `${routes.cart_clear_url}.js`;
	}

	fetch(url, config)
	.then(response => response.json())
	.then(data => {
		cartget();
	})
	.catch((error) => {
		console.error('Error:', error);
	});
}

function disabledSubmit() {
	if(document.getElementById("checkout")) {
		const checkoutBtn = document.getElementById("checkout");
		checkoutBtn.disabled = true;
	}
}